// ── 계약 관리 화면이 부르는 주소 묶음 (2026-10-15, 4단계 계약 통합 4-2) ───────────
// 계약 관리 화면 한 벌을 본사(/admin/contracts)·회사별·통합 메뉴 세 곳에서 쓰려고, 부품마다 글자로 박혀 있던
// 주소를 여기 한곳에 모았다. 화면(ContractManagement)이 묶음 하나를 받아 아래 부품들에 Context 로 내려준다.
// 4-5: 회사별(/admin/ext/{회사}/contracts)·통합(/admin/integrated-menus/{id}/contracts) 묶음은 scopedContractApi 가 만든다.
import { createContext, useContext } from 'react';

export const HQ_CONTRACT_API = Object.freeze({
  contracts: '/api/admin/contracts',                    // 목록·검색·한 건·등록·수정·삭제·이력·홍보물 연결
  fieldConfig: '/api/tm/contract-field-config',         // 등록 창 칸 설정 읽기
  fieldConfigSave: '/api/admin/contract-field-config',  // 칸 설정 저장(⚙)
  ticketTypes: '/api/admin/contract-ticket-types',      // 계약 상품
  productCategories: '/api/admin/product-categories',   // 상품 분류(기본상품 치환·홍보물 분류)
  callUsers: '/api/admin/tm/call-users',                // 상담자
  salesPersons: '/api/admin/meeting-inherit/sales-persons', // 마케팅 담당자
  promoItemsActive: '/api/admin/promotional-items/active',  // 홍보물 품목
  promoSuppliers: '/api/admin/promotional-suppliers',       // 홍보물 발주처(기본 택배사)
  promoOrders: '/api/admin/promotional-orders',             // 홍보물 주문 읽기·만들기
  promoWritable: true,      // 계약 창에서 홍보물 주문을 넣을 수 있나
  createCompanies: null,    // 콜 없이 직접 등록할 때 고를 회사들(null = 고르지 않음 — 서버가 정한다)
});

/**
 * 회사별·통합 계약 화면의 주소 묶음 (4-5). 응답 모양은 본사와 같다(서버 contract-scoped/mount-scoped-contracts.js).
 *   - 칸 설정(⚙)은 테넌트마다 하나라 본사 주소 그대로(파인그룹 DOT·LNJ 는 파인그룹 설정을 같이 쓴다).
 *   - 홍보물: 2026-10-14 결정 2-a 로 '보기만'이었다가 2026-10-15 사용자 "홍보물을 지금처럼 받으면 안돼?"로 본사와 같이 넣기 —
 *     품목·주문·항목·메모·계약에 붙이기 모두 이 화면 주소(서버 contract-scoped/mount-scoped-contract-promo.js, 주문 회사 = 계약 회사).
 *     발주처는 기본 택배사(배송 칸 첫 값)만 읽는다 — 본사 화면과 같은 주소·같은 권한.
 * @param {string} base  예: '/api/admin/ext/DOT/contracts'
 * @param {{ companies?: string[]|null }} opts  통합 메뉴만 — 직접 등록 때 고를 메뉴 회사들(결정 1-a)
 */
export function scopedContractApi(base, { companies = null } = {}) {
  return Object.freeze({
    ...HQ_CONTRACT_API,
    contracts: base,
    ticketTypes: `${base}/ticket-types`,
    productCategories: `${base}/product-categories`,
    callUsers: `${base}/call-users`,
    salesPersons: `${base}/sales-persons`,
    promoItemsActive: `${base}/promo-items`,
    promoOrders: `${base}/promo-orders`,
    promoWritable: true,
    createCompanies: Array.isArray(companies) && companies.length ? [...companies] : null,
  });
}

export const ContractApiContext = createContext(HQ_CONTRACT_API);

/** 계약 화면 부품이 쓰는 주소 묶음. ContractManagement 바깥에서 쓰면 본사 묶음. */
export function useContractApi() {
  return useContext(ContractApiContext);
}
